// Angular
import { Component, OnInit, ElementRef, ViewChild, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef } from '@angular/core';
// Material
// RXJS
import { debounceTime, distinctUntilChanged, tap, skip, take, delay } from 'rxjs/operators';
import { fromEvent, merge, Observable, of, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
// NGRX
import { Store } from '@ngrx/store';
// Services
// Models
import { AppState } from '../../../../../core/reducers';

// Components
import { RoleService } from '../../../../../mbs/services/role/role.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SubheaderService } from '../../../../../core/_base/layout';
import { ConfirmationService, LazyLoadEvent } from 'primeng/api';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { PermissionService } from '../../../../../mbs/services/permission/permission.service';

// Table with EDIT item in MODAL
// ARTICLE for table with sort/filter/paginator
// https://blog.angular-university.io/angular-material-data-table/
// https://v5.material.angular.io/components/table/overview
// https://v5.material.angular.io/components/sort/overview
// https://v5.material.angular.io/components/table/overview#sorting
// https://www.youtube.com/watch?v=NSt9CI3BXv4
@Component({
    selector: 'kt-roles-list',
    templateUrl: './roles-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RolesListComponent implements OnInit, OnDestroy {
    roles: any[];
    permissions: any[];
    roleCount: number;
    loading: boolean;
    columns: any[];

    // yeni kullanıcı ekle
    addRoleDialog = false;
    addRoleForm = new FormGroup({
        id: new FormControl(0),
        name: new FormControl('', [Validators.required, Validators.minLength(2)]),
    });

    // Subscriptions
    private subscriptions: Subscription[] = [];

    /**
     *
     * @param activatedRoute: ActivatedRoute
     * @param store: Store<AppState>
     * @param router: Router
     * @param subheaderService: SubheaderService
     * @param cdr: ChangeDetectorRef
     * @param roleService: RoleService
     * @param permissionService: PermissionService
     * @param confirmationService: ConfirmationService
     */
    constructor(
        private activatedRoute: ActivatedRoute,
        private store: Store<AppState>,
        private router: Router,
        private subheaderService: SubheaderService,
        private cdr: ChangeDetectorRef,
        private roleService: RoleService,
        private permissionService: PermissionService,
        private confirmationService: ConfirmationService
    ) {}

    ngOnInit(): void {
        this.columns = [
            { field: 'name', header: 'Adı' },
            { field: 'isSystemDefault', header: 'Sistem Tanımlı', custom: true },
            { field: 'actions', header: 'İşlemler', custom: true, width: '160px' },
        ];
        this.permissionService.getPermissions().subscribe((permissions) => {
            this.permissions = permissions
                .filter((t) => t.id < 10000)
                .map((t) => {
                    t.selected = false;
                    return t;
                });
        });
    }

    ngOnDestroy() {
        this.subscriptions.forEach((el) => el.unsubscribe());
    }

    showDialogForRoleEdit(rowData) {
        this.permissions = this.permissions.map((p) => {
            p.selected = rowData.permissions.some((pid) => pid === p.id);
            return p;
        });
        this.addRoleForm.patchValue(rowData);
        this.addRoleDialog = true;
    }

    getRoles(event: LazyLoadEvent) {
        this.loading = true;
        this.subscriptions.push(
            this.roleService.getRoles().subscribe({
                next: (users) => {
                    this.roles = users;
                    this.roleCount = users.length;
                },
                complete: () => {
                    this.loading = false;
                    this.cdr.detectChanges();
                },
            })
        );
    }

    addRole() {
        const role = this.addRoleForm.getRawValue();
        role.permissions = this.permissions.filter((t) => t.selected === true).map((p) => p.id);

        if (this.addRoleForm.controls.id.value === 0) {
            this.roleService.addRole(role).subscribe((response) => {
                this.addRoleDialog = false;
                this.getRoles(null);
                this.cdr.detectChanges();
            });
        } else {
            this.roleService.updateRole(role).subscribe((response) => {
                this.addRoleDialog = false;
                this.getRoles(null);
                this.cdr.detectChanges();
            });
        }
    }

    deleteRole(id: number) {
        this.confirmationService.confirm({
            message: 'Kayıt silinecektir! Onaylıyor musunuz?',
            accept: () => {
                this.roleService.removeRole(id).subscribe((response) => {
                    this.getRoles(null);
                    this.cdr.detectChanges();
                });
            },
            header: 'Onay',
            acceptLabel: 'Evet',
            rejectLabel: 'Hayır',
        });
    }

    checkAddRoleForm(controlName: string, validationType: string = null, validOrinvalidCheck: string = null): boolean {
        const control = this.addRoleForm.controls[controlName];
        if (!control) {
            return false;
        }

        if (validationType) {
            return control.hasError(validationType) && (control.dirty || control.touched);
        } else {
            return (control.touched || control.dirty) && validOrinvalidCheck === 'iv' ? !!control.errors : !control.errors;
        }
    }
}
